<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="intro_hd" role="doc-introduction">
<h1 class="h1fm" id="intro_hd"><span aria-label="page 3" id="page_3" role="doc-pagebreak"><span aria-label="page 4" id="page_4" role="doc-pagebreak"><span aria-label="page 5" id="page_5" role="doc-pagebreak"><span aria-label="page 6" id="page_6" role="doc-pagebreak"><span aria-label="page 7" id="page_7" role="doc-pagebreak">I<span class="smallcaps">NTRODUCTION</span></span></span></span></span></span></h1>
<p class="noindent">What better way to celebrate this beloved series than by raising a toast and sipping on something wonderful? Whether you are a bartending beginner or a seasoned potions master, this book of cocktails will take you on a delightful journey across subjects, seasons, and characters. From magical mocktails to enchantingly boozy beverages, there is something for everyone in these pages. Now dust off your cauldron and let us begin. Cheers!</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro.vue?31b5d282